import BaseObjectStore from './base-object.store';

class FeedbackStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'feedback';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new FeedbackStore();
